import { combineReducers } from '@oceanjs/core';
import { languageReducer } from './language';
import { mainMenuReducer } from './mainMenu';
import { themeReducer } from './theme';
export const rootReducer = combineReducers({
    language: languageReducer,
    theme: themeReducer,
    mainMenu: mainMenuReducer,
});
//# sourceMappingURL=reducer.js.map